import {Component, Input} from '@angular/core';
import {FormArray} from "@angular/forms";
import {FormService} from "../../../../../../../services/form.service";
import {ReferenceDataService} from "../../../../../../../services/reference-data.service";
import {UidService} from "../../../../../../../services/uid.service";
import {ChainService} from "../../../../../../../services/chain.service";
import {JoineryWorkshopNode} from "../../../../../../../shared/contracts";

@Component({
  selector: 'rb-joinery-workshop-nodes',
  templateUrl: './joinery-workshop-nodes.component.html',
  styleUrls: ['./joinery-workshop-nodes.component.scss']
})
export class JoineryWorkshopNodesComponent {
  @Input() records: FormArray;
  @Input() hdr: string;
  uid: number;

  constructor(
    public formService: FormService,
    public referenceDataService: ReferenceDataService,
    private uidService: UidService,
    public chainService: ChainService,
  ) {
    this.uid = uidService.generateUid();
  }

  computeTitle(base: string, index: number, data: string) {
    return base + " " + (index + 1) + (data ? (" - " + data) : "");
  }

  computeJoineryWorkshopHeader(): string {
    return this.hdr + "JoineryWorkshop";
  }

  computeJoineryWorkshopHeaderWithIndex(jwIndex: number): string {
    return this.computeJoineryWorkshopHeader() + jwIndex;
  }

  onConfirmedNode(node: JoineryWorkshopNode, index: number) {
    let formGroup = this.formService.createJoineryWorkshopNode(node);
    this.records.setControl(index, formGroup);
    this.formService.triggerTreeCuttingFromJoineryWorkshop(formGroup);
    this.formService.recomputeWoodCompositionEvaluation();
  }
}
